// extracted by mini-css-extract-plugin
export default {"player-box":"player-box__Ru7Hz","btn-play":"btn-play__iLMJP","video":"video__0fA6N","media":"media__ONWUe","error":"error__kN90R"};